import React from "react";
import { Box } from "@mui/material";

/**
 * Red required asterisk used next to mandatory labels.
 * Matches the design screenshot (Critical/Critical50).
 */
export default function RequiredAsterisk({ sx }) {
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        display: "inline-block",
        color: "#DE350B",
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        ...(sx || {}),
      }}
    >
      *
    </Box>
  );
}

